<template>
  <div class="default-layout">
    <div class="min-h-full flex relative w-full">
      <TheSidebar
        :open="sidebarOpen"
        @toggle="onSidebarToggle"
        v-if="!isMobile"
      >
        <div
          class="flex flex-1 flex-col justify-between text-xs text-abbey font-medium overflow-hidden"
        >
          <div class="flex flex-col flex-1 overflow-auto" id="top-tabs">
            <div class="flex-1">
              <NavigationTabItem
                :id="tab.id"
                :title="tab.title"
                :path="tab.path"
                :categories="tab.categories"
                :icon="tab.icon"
                :highlight="tab.id === currentTab"
                :currentUrl="currentUrl"
                :showMiniView="!sidebarOpen"
                :open="tab.id === currentDropdownTab"
                :openCategory="category"
                @click="onNavigationTabItemClick"
                :key="tab.id"
                v-for="tab in navigationItems"
              />
            </div>
          </div>
          <div id="bottom-tabs" class="pb-4" v-if="bottomTabs">
            <NavigationTabItem
              :id="tab.id"
              :title="tab.title"
              :path="tab.path"
              :icon="tab.icon"
              :showMiniView="!sidebarOpen"
              :key="tab.title"
              @click="onNavigationTabItemClick"
              v-for="tab in bottomTabs"
            />
          </div>
        </div>
      </TheSidebar>

      <div class="flex flex-col flex-1 max-h-screen overflow-y-scroll">
        <TheNavigation class="flex-shrink-0" />

        <div
          :class="[
            'content h-screen flex flex-col flex-grow flex-shrink-0 overflow-y-scroll',
            { mobile: isMobile }
          ]"
        >
          <router-view class="flex-grow flex-shrink-0" />

          <TheFooter class="flex-shrink-0 min-w-full px-6" />
        </div>
      </div>

      <TheBottomDrawer
        :activeSection="section"
        :category="category"
        :tabs="drawerTabs"
        :url="currentUrl"
        v-if="isMobile && drawerTabs.length"
      />
    </div>
  </div>
</template>

<style scoped>
.content {
  /* viewport height - TheNavigation height */
  max-height: calc(100vh - 64px);
}
.content.mobile {
  /* viewport height - (TheNavigation height + TheBottomDrawerHeight) */
  max-height: calc(100vh - (64px + 60px));
}
</style>

<script>
import {
  TheFooter,
  TheSidebar,
  TheBottomDrawer,
  NavigationTabItem,
  screenSizeMixin
} from '@listen360/alexandria'
import { mapActions, mapGetters } from 'vuex'

import TheNavigation from '@/components/TheNavigation'

export default {
  name: 'App',
  components: {
    NavigationTabItem,
    TheBottomDrawer,
    TheFooter,
    TheNavigation,
    TheSidebar
  },
  mixins: [screenSizeMixin],
  data() {
    const currentDropdownTab = localStorage.getItem('l360-current-dropdown-tab')

    return {
      currentDropdownTab,
      currentUrl: window.location.href
    }
  },
  created() {
    const sidebarOpen =
      localStorage.getItem('l360-sidebar-open') === 'true' ||
      localStorage.getItem('l360-sidebar-open') == null

    this.toggleSidebar(sidebarOpen)

    this.getNavigationItems()
  },
  computed: {
    ...mapGetters({
      currentEnvironment: 'user/currentEnvironment',
      currentSubsidiary: 'user/currentSubsidiary',
      isForbidden: 'user/isForbidden',
      isLoggedIn: 'user/isLoggedIn',
      category: 'sidebar/category',
      navigationItems: 'sidebar/navigationItems',
      errorLoadingNavigationItems: 'sidebar/errorLoadingNavigationItems',
      isLoadingNavigationItems: 'sidebar/isLoadingNavigationItems',
      sidebarOpen: 'sidebar/open',
      currentTab: 'sidebar/tab',
      screenHeight: 'screen/height',
      isMobile: 'screen/isMobile'
    }),
    path() {
      return this.$route.path
    },
    fullPath() {
      return this.$route.fullPath
    },
    orgId() {
      return this.$route.params.orgId
    },
    section() {
      return this.$route.params.section
    },

    bottomTabs() {
      return [
        {
          id: 'admin',
          title: 'Admin',
          icon: 'wrench',
          path: '/admin'
        }
      ]
    },
    drawerTabs() {
      return this.navigationItems.length
        ? [
            ...this.navigationItems,
            {
              id: 'more',
              title: 'More',
              icon: 'ellipsis-v',
              categories: [
                {
                  id: 'support',
                  title: 'Support',
                  path: 'https://support.listen360.com/'
                }
              ]
            }
          ]
        : []
    }
  },
  methods: {
    ...mapActions({
      setTab: 'sidebar/setTab',
      getNavigationItems: 'sidebar/getNavigationItems',
      toggleSidebar: 'sidebar/toggleSidebar'
    }),
    onNavigationTabItemClick({ id, path }) {
      if (path) {
        window.location.href = path
      } else if (!this.sidebarOpen) {
        this.toggleSidebar()
        this.setDropdownTab({ id, keepOpen: true })
      } else {
        this.setDropdownTab({ id })
      }
    },
    onSidebarToggle() {
      const isOpen = !this.sidebarOpen
      this.toggleSidebar()
      localStorage.setItem('l360-sidebar-open', isOpen)
    },
    setDropdownTab({ id, keepOpen }) {
      this.currentDropdownTab =
        this.currentDropdownTab !== id || keepOpen ? id : null

      if (this.currentDropdownTab) {
        localStorage.setItem(
          'l360-current-dropdown-tab',
          this.currentDropdownTab
        )
      } else {
        localStorage.removeItem('l360-current-dropdown-tab')
      }
    }
  },
  watch: {
    fullPath() {
      // whenever this.$route.fullPath changes, update currentUrl with full url from window
      this.currentUrl = window.location.href
    }
  }
}
</script>
